// extracted by mini-css-extract-plugin
export default {"alert":"alert-3D_NDz","heading":"heading-2MTnhQ","info":"info-1KbwB7","success":"success-2z-2nu","warning":"warning-JN5JkW","error":"error-1SsKSU"};